import { SVGIcon } from '@superops/super-icons';
import {
  Button,
  Heading,
  Modal,
  Page,
  TextContainer
} from '@superops/ui-design-system';
import { withErrorBoundary, getTranslatedText, toast } from '@nile/components';
import React, { useCallback, useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { DELETE_PDF_HISTORY } from '@nile/reports/src/modules/reports/graphql';
import { useMutation } from '@apollo/client';
import { AccountClient } from '@nile/graphql';
import HistoryTable from '../HistoryTable';

function DownloadHistory(props) {
  const { callBack, data } = props;
  const [records, setRecords] = useState([]);
  const [enalbeResolveAction, setEnalbeResolveAction] = useState(false);
  const [active, setActive] = useState(false);
  const handleChange = useCallback(() => setActive(!active), [active]);
  const intl = useIntl();

  const context = {
    setRecords,
    records
  };

  const [deletePdfHistory] = useMutation(DELETE_PDF_HISTORY, {
    client: AccountClient,
    onCompleted: (res) => {
      if (res) {
        toast('success', 'toast.reports.history.delete.success', undefined, {
          reportType: 'CSV'
        });
        setRecords([]);
      }
    },
    onError: () => {
      toast('error', 'error.page.config.default.title');
    }
  });

  const actionClickDelete = (e, callback) => {
    if (e) {
      //tableInline single pdf history delete
      deletePdfHistory({
        variables: {
          ids: [e.inventoryId]
        }
      }).then(() => {
        if (callback) callback();
      });
    } else {
      //bulk pdf history delete
      deletePdfHistory({
        variables: {
          ids: records.map((item) => item.inventoryId)
        }
      });
    }
  };

  useEffect(() => {
    if (records && records?.length > 0) {
      setEnalbeResolveAction(true);
    } else {
      setEnalbeResolveAction(false);
    }
  }, [records]);

  const activator = (
    <Button
      onClick={handleChange}
      icon={<SVGIcon name="Delete" />}
      disabled={!enalbeResolveAction}
    >
      <FormattedMessage id="common.delete" />
    </Button>
  );

  return (
    <>
      <Modal open showCloseButton={false} onClose={() => callBack()} large>
        <Page
          variant="secondary"
          divider
          contentHeight="90px"
          title={
            <div className="pt-5 pb-5">
              <Heading element="h1">
                <FormattedMessage id="reports.report.download.history.modal.title" />
              </Heading>
            </div>
          }
          primaryAction={
            <div className="fx center">
              {records.length > 0 && (
                <div className="fx">
                  <Button outline selected>
                    {records.length}{' '}
                    <FormattedMessage id="rmm.patchManagement.bulkActions.selected" />
                  </Button>

                  <div className="ml-10">
                    <Modal
                      activator={activator}
                      open={active}
                      onClose={handleChange}
                      variant="confirmation"
                      title={getTranslatedText(
                        intl,
                        'reports.history.bulkAction.heading',
                        {
                          reportType: 'CSV'
                        }
                      )}
                      primaryAction={{
                        destructive: true,
                        content: getTranslatedText(intl, 'common.delete'),
                        onAction: () => {
                          handleChange();
                          actionClickDelete();
                        }
                      }}
                      secondaryActions={[
                        {
                          content: getTranslatedText(intl, 'common.cancel'),
                          onAction: handleChange
                        }
                      ]}
                    >
                      <TextContainer>
                        <FormattedMessage
                          id="reports.history.bulkAction.description"
                          values={{ reportType: 'CSV' }}
                        />
                      </TextContainer>
                    </Modal>
                  </div>
                </div>
              )}
              <div className="pt-5 pb-5 ml-10">
                <Button
                  plainSecondary
                  icon={<SVGIcon name="Close" />}
                  onClick={() => callBack()}
                />
              </div>
            </div>
          }
        >
          <HistoryTable
            data={data}
            context={context}
            actionClickDelete={actionClickDelete}
            enableDeleteAction
          />
        </Page>
      </Modal>
    </>
  );
}

export default withErrorBoundary(DownloadHistory);
